import { find, isEmpty } from 'lodash-es';

export default function FindPermissionFilter() {
  'ngInject';

  return (permissions, permissionName: string): boolean => {
    return !isEmpty(
      find(permissions, {
        name: permissionName
      })
    );
  };
}
